export const TextFormatToolbar = ({ show, onFormat, isMobileToolbar }) => {
    if (!show && !isMobileToolbar) return null;
    const handleMouseDown = (e) => { e.preventDefault(); };
    return (
        <div className={`format-toolbar ${isMobileToolbar ? 'mobile' : ''}`} onMouseDown={handleMouseDown}>
            <button type="button" onClick={() => onFormat('**')} title="굵게"><b>B</b></button>
            <button type="button" onClick={() => onFormat('*')}  title="기울임"><i>I</i></button>
            <button type="button" onClick={() => onFormat('~~')} title="취소선"><s>S</s></button>
            <button type="button" onClick={() => onFormat('code')} title="코드 블록"><code>&lt;/&gt;</code></button>
        </div>
    );
};
